import * as SQLite from 'expo-sqlite';
import { DB_NAME, DB_VERSION } from './config';
import type { SQLiteDatabase } from 'expo-sqlite';

/**
 * Promesa singleton de la DB.
 * Nunca uses openDatabaseAsync() directamente en la app.
 */
let dbPromise: Promise<SQLiteDatabase> | null = null;

async function migrateIfNeeded(db: SQLiteDatabase) {
  // Leemos la versión actual
  const row = await db.getFirstAsync<{ user_version: number }>(
    'PRAGMA user_version'
  );
  const currentVersion = row?.user_version ?? 0;

  if (currentVersion >= DB_VERSION) return;

  // Ejemplo de migraciones simples
  await db.withExclusiveTransactionAsync(async (tx) => {
    switch (currentVersion) {
      case 0:
        await tx.execAsync(`
          CREATE TABLE IF NOT EXISTS users (
            id INTEGER PRIMARY KEY AUTOINCREMENT,
            name TEXT NOT NULL,
            email TEXT UNIQUE
          );

          PRAGMA user_version = ${DB_VERSION};
        `);
        break;
      // case 1: ... otras migraciones
      default:
        break;
    }
  });
}

/**
 * Devuelve siempre la misma instancia de SQLiteDatabase.
 */
export function getRawDatabase(): Promise<SQLiteDatabase> {
  if (!dbPromise) {
    dbPromise = (async () => {
      const db = await SQLite.openDatabaseAsync(DB_NAME);

      // PRAGMAs recomendables
      await db.execAsync(`
        PRAGMA journal_mode = WAL;
        PRAGMA foreign_keys = ON;
      `);

    //   await migrateIfNeeded(db); // Desactivar migraciones por ahora

      return db;
    })();
  }
  return dbPromise;
}
